export default __webpack_public_path__ + "media/shipment/DPD-c40f0c66.svg";